// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CsV54","body":"styles_body__lqSHt","blueline":"styles_blueline__w8wta","botaoSalvar":"styles_botaoSalvar__j4iJs"};